export const FETCH_ASSIGNMENT = "FETCH_ASSIGNMENT";
export const FETCH_ASSIGNMENT_REQUEST = "FETCH_ASSIGNMENT_REQUEST";
export const FETCH_ASSIGNMENT_SUCCESS = "FETCH_ASSIGNMENT_SUCCESS";
export const FETCH_ASSIGNMENT_FAILURE = "FETCH_ASSIGNMENT_FAILURE";
export const FETCH_TOEIC_SUCCESS = "FETCH_TOEIC_SUCCESS";